import { createGlobalStyle } from 'styled-components';

export const theme = {
  light: '#F3F5F9',
  background: '#F3F5F9',
  primary: '#002D72',
  accent: '#F0C23B',
};

export const GlobalStyles = createGlobalStyle`
  * {
    margin:0;
    padding:0;
    font-family: Roboto;
    box-sizing: border-box;
  };
  html, body {
    height: 100%;
    transition: all 500ms ease;
    font-size:1.2rem; 
    box-sizing: border-box;
  };
  *,
  *:before,
  *:after {
  box-sizing: inherit;
  }
  a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
  }
  a, a:hover, a:focus, a:active {

    text-decoration: none;
      color: inherit;
  }
`;
